import { handleActions } from 'redux-actions'

import { ContentFormStatusResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

import * as rawActions from '../actions'

const defaultState: ContentFormStatusResponse[] = []

export default handleActions(
  {
    [rawActions.setAnswersStatusesCount.toString()](state, action) {
      return [...action.payload]
    },
    [rawActions.resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
